import PropTypes from 'prop-types'
import React from 'react';
import { StyleSheet, View, TouchableOpacity, Platform, } from 'react-native';
import Text from 'app/components/Text'
import apiActions from 'app/utils/apiActions'
import textHelpers from 'app/utils/textHelpers'
import timeHelpers from 'app/utils/timeHelpers'
import colorHelpers from 'app/utils/colorHelpers'
import * as RootNavigation from 'app/utils/RootNavigation.js';
import Svg, { Path, Ellipse, Circle, Rect } from 'react-native-svg';
import { styleSheet, colors, sizes, screenRatio } from 'app/utils/styleSheet'

// import { BlurView } from 'expo-blur';
import { Ionicons, Entypo } from '@expo/vector-icons';

export default class Value extends React.Component {

  static propTypes = {
    value: PropTypes.object.isRequired,
    onPress: PropTypes.func,
    // onLongPress: PropTypes.func,
    showQuickActions: PropTypes.bool,
    onShowQuickActions: PropTypes.func,
    onHideQuickActions: PropTypes.func,
    selected: PropTypes.bool,
  }

  constructor(props){
    super(props)
    this.state = {
      // showQuickActions: false
    }
  }

  // async componentDidUpdate(prevProps, prevState, snapshot){
  //   if(this.props.hideQuickAction != prevProps.hideQuickAction){

  //   }
  // }

  render(){
    let { value, onPress, onLongPress, style, maxWidth, conduitSymbols, circle, 
      showQuickActions, onShowQuickActions, onHideQuickActions, selected } = this.props
    // let { showQuickActions } = this.state
    let paddingHorizontal = 15
    let doneToday = textHelpers.wasDoneToday(value)
    // selected = true
    return (
      <View
        ref={(ref) => { this.ref = ref }}
        onLayout={({nativeEvent}) => {
          if (this.ref) {
            this.ref.measure((x, y, width, height, pageX, pageY) => {
              // console.log(`${value.text}: x:${x}, y:${y}, w:${width}, h:${height}, px:${pageX}, py:${pageY}`);
              let absX = pageX + (width/2)
              let absY = pageY + (height/2)
              this.setState({absX, absY})
            })
          }
        }}
        // style={{borderWidth: 5, borderColor: 'red'}}
        style={[
          value.id == 0 || value.filler ? {opacity: 0} : null,
        ]}
      >
        <TouchableOpacity
          {...this.props}
          onLongPress={() => {
            !!onLongPress && onLongPress()
            // if(quickActions) this.setState({showQuickActions: true})
            !!onShowQuickActions && onShowQuickActions()
          }}
          style={styles.wrapper}
        >
          <View style={[
            circle ? styles.circleItem : styles.item,
            !!doneToday ? styles.doneTodayItem : null,
            // {paddingHorizontal},
            // circle ? {borderWidth: 0} : null,
            selected ? styles.selectedItem : null,
            style || null,
            {opacity: 1},
          ]}>
            {this.renderBlurBg(value, selected)}
            <View style={styles.textWrapper}>
              {/*conduitSymbols && <Text style={styles.bottomSymbol}>{value.symbol}</Text>*/}
              <Text 
                style={[
                  styles.text,
                  selected ? styles.selectedText : null,
                  this.scaleFont(value.text),
                  !!maxWidth ? { maxWidth: maxWidth - (paddingHorizontal*2)} : null
                ]} 
                numberOfLines={3}
              >
                {!conduitSymbols && value.symbol}{value.text}{/*!conduitSymbols && value.family_symbols*/}
              </Text>
              {/*conduitSymbols && <Text style={styles.topSymbol}>{value.family_symbols}</Text>*/}
            </View>
            {this.renderProgressBar(doneToday)}
          </View>
        </TouchableOpacity>
        {showQuickActions && this.renderQuickActions()}        
        {conduitSymbols && <Text style={styles.outterTopSymbol}>{value.family_symbols}</Text>}
        {conduitSymbols && <Text style={styles.outterBottomSymbol}>{value.symbol}</Text>}
      </View>
    );
  }

  renderProgressBar = (doneToday=0) => {
    let { value, circle } = this.props
    let { progress_at=[], level } = value
    let steps = level == 1 ? 0 : level == 2 ? 1 : 7
    steps = 7
    
    let doneSinceMilestone = textHelpers.doneSinceMilestone(value)
    // console.log(value.text, lastMilestone, doneSinceMilestone)

    let SVG = null
    if(circle){
      let R = 50
      let C = 2*Math.PI*R
      let slot = C/7
      let slotFill = slot * 0.8
      let slotGap = slot * 0.2
      let offset = -(C * 0.25)
      offset = -(slotGap/2)

      let dashArray = new Array(6).fill([slotFill, slotGap]).flat()
      let dashCount = doneSinceMilestone.length
      let progressDashArray = new Array(doneSinceMilestone.length).fill([slotFill, slotGap]).flat()
      if(!!value.completed_at){
        progressDashArray = [C]
        offset = 0
      }
      progressDashArray.push([0,C]) // clear the end

      let todayDashArray = []
      let todayOffset = 0
      if(doneToday){
        if(!!value.completed_at){
          todayDashArray = [C]
          offset = 0
        }
        else {
          doneSinceMilestone.map((p) => {
            if(!!p && timeHelpers.wasToday(p.timestamp)){
              todayDashArray.push([slotFill, slotGap])
            }
            else {
              todayOffset -= (slotFill + slotGap)
            }
          })
        }
        todayDashArray.push([0,C]) // clear the end
      }


      let trimColor = '#444'
      trimColor = colors.placeholder
      let emptyColor = colors.fill
      // let progressColor = doneToday ? colors.activeHighlight : colors.active
      // let strokeWidth = doneToday ? (R/4) : (R/5)

      SVG = (
        <View style={[styles.pathWrapper, styles.svgWrapper]}>
          {/*<View style={styles.pathWrapper}>
            <Svg height="100%" width="100%" viewBox="0 0 100 100">
              <Circle cx={R} cy={R} r={R} stroke={trimColor} strokeWidth={R/8} fill="transparent" strokeDasharray={[C]} strokeDashoffset={offset} />
            </Svg>
          </View>*/}
          <View style={styles.pathWrapper}>
            <Svg height="100%" width="100%" viewBox="0 0 100 100">
              <Circle cx={R} cy={R} r={R} stroke={emptyColor} strokeWidth={R/8} fill="transparent" strokeDasharray={dashArray} strokeDashoffset={offset} />
            </Svg>
          </View>
          {progressDashArray.length > 0 && (
            <View style={styles.pathWrapper}>
              <Svg height="100%" width="100%" viewBox="0 0 100 100">
                <Circle cx={R} cy={R} r={R} stroke={colors.active} strokeWidth={R/5} fill="transparent" strokeDasharray={progressDashArray} strokeDashoffset={offset} />
              </Svg>
            </View>
          )}
          {todayDashArray.length > 0 && (
            <View style={styles.pathWrapper}>
              <Svg height="100%" width="100%" viewBox="0 0 100 100">
                <Circle cx={R} cy={R} r={R} stroke={colors.activeHighlight} strokeWidth={R/4} fill="transparent" strokeDasharray={todayDashArray} strokeDashoffset={offset + todayOffset} />
              </Svg>
            </View>
          )}
          {/*
          */}
        </View>
      )
      return SVG
    }

    return (
      <View style={{alignSelf: 'stretch'}}>
      <View style={styles.progressBar}>
        {/*doneSinceMilestone.length >= 7 || (!!value.completed_at) ? (*/}
        {!!value.completed_at ? (
          <View style={[
            styles.progressNotch, 
            styles.completedNotch,
            !!doneToday ? styles.completedTodayNotch : null,
          ]} />
        ) : (
          new Array(steps).fill(0).map((x,i) => {
            const index = i
            if(!!doneSinceMilestone[i]){
              let doneStyle = !!doneToday && timeHelpers.wasToday(doneSinceMilestone[i].timestamp)
              return (
                <View key={i} style={[
                  styles.progressNotch, 
                  styles.completedNotch, 
                  doneStyle ? styles.completedTodayNotch : null,
                ]} />
              )
            }
            else {
              return (
                <View key={i} style={[styles.progressNotch]} />
              )
            }
          })
        )}
      </View>
      {SVG}
      </View>
    )
  }

  renderQuickActions = () => {
    let { value, filterToFamily, onDeselect, onHideQuickActions } = this.props
    return (
      <View style={styles.quickActionsWrapper}>
        <TouchableOpacity onPress={this.createProgress}>
          <Ionicons name={'ios-checkbox-outline'} color={'white'} style={styles.icon} />
        </TouchableOpacity>
        <TouchableOpacity onPress={() => RootNavigation.push('Edit', {value})}>
          <Ionicons name={'ios-brush'} color={'white'} style={styles.icon} />
        </TouchableOpacity>
        {/*
        <TouchableOpacity onPress={filterToFamily}>
          <Entypo name={'flow-tree'} color={'white'} style={styles.icon} />
        </TouchableOpacity>
        <TouchableOpacity onPress={() => alert('history')}>
          <Ionicons name={'ios-timer'} color={'white'} style={styles.icon} />
        </TouchableOpacity>
        */}
        <TouchableOpacity onPress={this.touchValue}>
          <Ionicons name={'md-finger-print'} color={'white'} style={styles.icon} />
        </TouchableOpacity>
        <TouchableOpacity onPress={() => {
          !!onDeselect && onDeselect()
          // this.setState({showQuickActions: false})
          !!onHideQuickActions && onHideQuickActions()
        }}>
          <Ionicons name={'md-close'} color={'white'} style={styles.icon} />
        </TouchableOpacity>
      </View>
    )
  }

  createProgress = async () => {
    let { value, onUpdate, onHideQuickActions, onDeselect, } = this.props
    let progress_at = value.progress_at
    progress_at.unshift(new Date().toUTCString())
    let data = {
      value: {progress_at}
    }
    value = await apiActions.request(`values/${value.id}`, 'PATCH', data)
    console.log(value)
    onUpdate(value)
    !!onHideQuickActions && onHideQuickActions()
    !!onDeselect && onDeselect()

    let doneSinceMilestone = textHelpers.doneSinceMilestone(value)
    if(doneSinceMilestone.length >= 7){
      let revise = confirm('ready to revise/extend?')
      if(revise){
        RootNavigation.push('Revise', {value, id: value.id})
      }
    }
  }

  touchValue = async () => {
    let { value, onUpdate, onHideQuickActions, onDeselect, } = this.props
    let data = {
      value: {updated_at: new Date().toUTCString()}
    }
    value = await apiActions.request(`values/${value.id}`, 'PATCH', data)
    console.log(value)
    onUpdate(value)
    !!onHideQuickActions && onHideQuickActions()
    !!onDeselect && onDeselect()
  }

  scaleFont = (text='') => {
    let fontSize = sizes.default
    if(text.length > 10){
      fontSize -= ((text.length-10) * 0.3)
    }
    fontSize = Math.max(sizes.base, fontSize)
    let lineHeight = fontSize *1.2
    return { fontSize, lineHeight }
  }

  renderBlurBg = (value, selected) => {
    let { circle, blur, } = this.props
    if(!circle) return null
    let intensity = selected ? 15 : 85
    if(blur === false) intensity = 0
    // let allSymbols = (value.symbol || '') + (!!value.family_symbols ? value.family_symbols.join('') : '')
    // let allSymbols = (value.family_symbols || []).concat([value.symbol]).filter(x => !!x)
    let allSymbols = [value.symbol].concat(value.family_symbols || []).filter(x => !!x)
    if(!!!allSymbols) return null
    return (
      <View style={styles.blurWrapper}>
        {allSymbols.length == 1 && (
          <Text style={[styles.blurSymbol]} numberOfLines={1}>
            {allSymbols}
          </Text>
        )}
        {allSymbols.length > 1 && (
          <View style={[styles.symbolBgWrapper, styles.multiWrapper]}>
            <View style={styles.multiRow}>
              <Text style={[styles.blurSymbol, styles.blurSymbolMulti]}>
                {allSymbols[0]}
              </Text>
              <Text style={[styles.blurSymbol, styles.blurSymbolMulti]}>
                {allSymbols[1]}
              </Text>
            </View>
            <View style={styles.multiRow}>
              <Text style={[styles.blurSymbol, styles.blurSymbolMulti]}>
                {allSymbols[2]}
              </Text>
              <Text style={[styles.blurSymbol, styles.blurSymbolMulti]}>
                {allSymbols[3]}
              </Text>
            </View>
          </View>
        )}  
        {/*<BlurView intensity={intensity} style={styles.blur} />*/}
        {/*allSymbols.length == 1 && <View style={styles.blurCurtain} />*/}
        <View style={styles.blurCurtain} />
      </View>
    )
  }
}

const styles = StyleSheet.create({  
  wrapper: Platform.OS == 'web' ?  {
    // borderWidth: 1,
    // borderColor: 'white',
  } : {
    // transform: [
    //   {rotateX: '-10deg'},
    //   {perspective: 100},
    // ] 
  },
  item: {
    minWidth: 150 *screenRatio,
    flexDirection: 'column',
    alignItems: 'center',
    
    borderWidth: 1, 
    // borderBottomWidth: 1, 
    borderColor: '#444',
    padding: 10 *screenRatio,
    paddingBottom: 5 *screenRatio,
    borderRadius: 20,
    // borderTopRightRadius: 10,
    // borderTopLeftRadius: 10,
    // borderBottomRightRadius: 20,
    // borderBottomLeftRadius: 20,
    // borderStyle: 'dashed',
    // borderStyle: 'dotted',
    // marginRight: 10 *screenRatio,
    // marginHorizontal: 6 *screenRatio,
    backgroundColor: colors.empty,
  },
  circleItem: {
    width: 100 *screenRatio,
    height: 100 *screenRatio,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',    
    // borderWidth: 1.5, 
    borderRadius: 50 *screenRatio,
    borderColor: '#444',
    padding: 10 *screenRatio,
    marginHorizontal: 6 *screenRatio,
    backgroundColor: colors.empty,
    overflow: 'hidden',
  },
  selectedItem: {
    backgroundColor: colors.foreground,
  },
  doneTodayItem: {
    // backgroundColor: '#120202',
    // borderColor: colors.activeHighlight,
  },
  textWrapper: {

  },
  text: {
    color: colors.foreground,
    textAlign: 'center',
  },
  selectedText: {
    color: colors.empty,
    textShadowColor: colors.foreground, 
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2, 
    backgroundColor: colorHelpers.hexToRgbaString(colors.foreground, 0.2),
    borderRadius: sizes.base,
  },
  quickActionsWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    backgroundColor: colors.fill,
    borderRadius: 5,
    padding: 5,
    paddingRight: 0,
    position: 'absolute',
    // bottom: '100%',
    right: 0,
  },
  icon: {
    marginRight: sizes.base,
    fontSize: sizes.itemHeight,
  },
  progressBar: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'space-around',
    paddingRight: 8,
    paddingLeft: 4,
    marginTop: 3,
  },
  progressNotch: {
    flex: 1,
    backgroundColor: colors.trim,
    marginLeft: 4,
    height: 2,
  },
  completedNotch: {
    backgroundColor: colors.active,
  },
  completedTodayNotch: {
    backgroundColor: colors.activeHighlight,
  },
  topSymbol: {
    position: 'absolute',
    bottom: '150%',
    right: 0,
  },
  bottomSymbol: {
    position: 'absolute',
    top: '150%',
    left: 0,
  },
  outterTopSymbol: {
    position: 'absolute',
    bottom: '100%',
    right: 0, 
    left: 0,
    textAlign: 'center',
  },
  outterBottomSymbol: {
    position: 'absolute',
    top: '100%',
    left: 0, 
    right: 0,
    textAlign: 'center',
  },
  blurWrapper: {
    ...StyleSheet.absoluteFillObject,    
    justifyContent: 'center',
    alignItems: 'center',
    left: -50, right: -50,
    borderRadius: 50 *screenRatio,
    overflow: 'hidden',
  },
  blurSymbol: {
    position: 'absolute',
    fontSize: 150 *screenRatio,
    textAlign: 'center',
    borderRadius: 50 *screenRatio,
    overflow: 'hidden',
  },
  blurSymbolMulti: {
    position: 'relative',
    // paddingHorizontal: 50,
    fontSize: 50 *screenRatio,    
  },
  blur: {
    ...StyleSheet.absoluteFillObject,
    top: -1, right: -1, bottom: -1, left: -1,
    borderRadius: 52 *screenRatio,
    overflow: 'hidden',
  },
  blurCurtain: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: `rgba(0,0,0, 0.2)`,
    borderRadius: 50 *screenRatio,
    overflow: 'hidden',
  },
  symbolBgWrapper: {
    position: 'absolute',
    top: 4, right: 54, bottom: 4, left: 54,
    // top: 4, right: 4, bottom: 4, left: 4,
    borderRadius: (50 *screenRatio)-8,
    overflow: 'hidden',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  multiWrapper: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
  },
  multiRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: -10,
  },
  svgWrapper: {
    transform: [{
      rotate: '90deg',
    }],
  },
  pathWrapper: {
    ...StyleSheet.absoluteFillObject,
    width: '100%', 
    height: 100 *screenRatio,
  }
})